<template>
    <div>
        <v-row justify="center">
            <v-col cols="12" lg="10" class="admin-container">
                <!-- Filters Card -->
                <v-card class="filters-card" elevation="2">
                    <v-card-title class="filters-title">
                        <v-icon color="#0d2c6d" class="ml-2">mdi-filter</v-icon>
                        סינון היסטוריית שיחות
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center">
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="חיפוש שיחה"
                                    outlined dense hide-details background-color="white"
                                    class="search-field" @input="handleSearchInput"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field v-model="startDate" label="הצג מתאריך" type="datetime-local" outlined
                                    dense hide-details prepend-inner-icon="mdi-calendar-start" class="date-field"
                                    @change="debouncedFetchCalls"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field v-model="endDate" label="עד תאריך" type="datetime-local" outlined dense
                                    hide-details prepend-inner-icon="mdi-calendar-end" class="date-field"
                                    @change="debouncedFetchCalls"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- Call History Data Table Card -->
                <v-card class="data-table-card" elevation="2">
                    <v-card-title class="data-table-title">
                        <v-icon color="#0d2c6d" class="ml-2">mdi-phone-log</v-icon>
                        היסטוריית שיחות
                        <v-chip v-if="calls.length > 0" color="#0d2c6d" text-color="white" small class="ml-2 mr-2">
                            {{ totalItems }} שיחות
                        </v-chip>
                    </v-card-title>

                    <v-data-table id="table1" :headers="headers" :items="calls" sort-by="start_at" sort-desc
                        :search="search" class="calls-table" :loading="progressShow" loading-text="טוען נתונים..."
                        :server-items-length="totalItems" :items-per-page="itemsPerPage" :page.sync="currentPage"
                        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @update:items-per-page="onItemsPerPageChange"
                        @update:page="onPageChange" @update:sort-by="onSortChange" @update:sort-desc="onSortChange"
                        :footer-props="{
                            'items-per-page-options': [20, 50, 100, 500], 'items-per-page-text': 'שורות בעמוד:', showFirstLastPage: true,
                            firstIcon: 'mdi-chevron-double-left',
                            lastIcon: 'mdi-chevron-double-right',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right'
                        }">
                        <template v-if="$vuetify.breakpoint.mdAndUp" v-for="header in headers"
                            v-slot:[`header.${header.value}`]="{ header }">
                            <span class="table-header-text">{{ header.text }}</span>
                        </template>

                        <template v-if="$vuetify.breakpoint.mdAndUp" #item="{ item, index }">
                            <tr class="table-row">
                                <td class="table-cell">{{ index + 1 }}</td>
                                <td class="table-cell">
                                    <div class="caller-name">
                                        <v-icon small color="#0d2c6d" class="ml-1">mdi-account</v-icon>
                                        {{ item?.subscriber_id?.name || 'לא ידוע' }}
                                    </div>
                                </td>
                                <td class="table-cell">
                                    <div class="caller-number">
                                        <v-icon small color="#0d2c6d" class="ml-1">mdi-phone</v-icon>
                                        {{ item.src }}
                                    </div>
                                </td>
                                <td class="table-cell">
                                    <v-chip small color="#6a6aec" text-color="white" class="destination-chip">
                                        {{ item.line_number }}
                                    </v-chip>
                                </td>
                                <td class="table-cell">
                                    <v-btn small text color="primary" @click="openDetailsDialog(item)"
                                        class="details-button">
                                        <v-icon small left>mdi-information-outline</v-icon>
                                        הצג פעולות
                                    </v-btn>
                                </td>
                                <td class="table-cell">
                                    <div class="date-display">
                                        <v-icon small color="#0d2c6d" class="ml-1">mdi-calendar-clock</v-icon>
                                        {{ item.start }}
                                    </div>
                                </td>
                                <td class="table-cell">
                                    <div class="duration-display">
                                        <v-icon small color="#0d2c6d" class="ml-1">mdi-clock-outline</v-icon>
                                        {{ item.duration }}
                                    </div>
                                </td>
                            </tr>
                        </template>

                        <!-- Mobile display -->
                        <template v-slot:item.last_context.context="{ item }">
                            <v-btn small text color="primary" @click="openDetailsDialog(item)" class="details-button">
                                <v-icon small left>mdi-information-outline</v-icon>
                                הצג פעולות
                            </v-btn>
                        </template>

                        <template v-slot:no-data>
                            <v-row v-if="progressShow" class="my-5">
                                <v-col class="d-flex justify-center">
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </v-col>
                            </v-row>
                            <div class="empty-state">
                                <v-icon size="64" color="#0d2c6d">mdi-phone-off</v-icon>
                                <span class="empty-text">לא נמצאו שיחות בטווח התאריכים שנבחר</span>
                                <v-btn color="primary" @click="resetDates" class="mt-4">
                                    <v-icon left>mdi-calendar-refresh</v-icon>
                                    אפס תאריכים
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <!-- Dialogs -->
        <ContextDetailsDialog v-model="contextDetailsDialog" v-if="contextDetailsDialog" :callDetails="callDetails" />
        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </div>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import ContextDetailsDialog from '@/components/callHistory/dialogs/ContextDetailsDialog.vue'
import Auth from '@/services/auth.service.js'
import DatePicker from "@/components/widgets/DatePicker";
import Utils from "@/util/utils";
import moment from "moment-timezone";
import _ from 'lodash'; // Import lodash or use another debounce utility

export default {
    components: {
        SnackBar,
        ContextDetailsDialog,
        DatePicker
    },
    data: () => ({
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        lineNumber: "",
        progressShow: false,
        callDetails: [],
        contextDetailsDialog: false,
        search: "",
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 20,
        sortBy: 'start_at',
        sortDesc: true,
        calls: [],
        headers: [
            { text: '#', value: "index", sortable: false, width: '50px' },
            { text: 'שם', align: 'start', value: 'subscriber_id.name' },
            { text: 'מספר המתקשר', value: 'src' },
            { text: 'יעד התקשרות', value: 'line_number', width: '150px' },
            { text: 'שלוחה/מיקום האזנה', value: 'last_context.context', width: '180px' },
            { text: 'תאריך התקשרות', value: 'start_at' },
            { text: 'זמן שיחה', value: 'duration', width: '120px' },
        ],
        startDate: "",
        endDate: "",
    }),
    methods: {
        async callHistory() {
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");
                const datesJSON = JSON.stringify({ startDate: this.startDate, endDate: this.endDate });

                const query = new URLSearchParams({
                    page: this.currentPage,
                    itemsPerPage: this.itemsPerPage,
                    sortBy: this.sortBy || '',
                    sortDesc: this.sortDesc ? 'desc' : 'asc',
                    search: this.search || ''
                }).toString();

                let api = process.env.VUE_APP_BASE_URL + `/call_history/get_history_calls?${query}`;
                const res = await fetch(api, ApiServices.requestOptions("POST", datesJSON, token));
                const jsonObject = await res.json();
                this.progressShow = false;

                if (res.status >= 400) {
                    this.showSnackBar("שגיאה בקבלת נתונים", "red");
                } else if (res.status === 200) {
                    this.calls = jsonObject.items || [];
                    this.totalItems = jsonObject?.totalItems || 0;
                    this.formatDetails();
                }
            } catch (error) {
                this.progressShow = false;
                this.showSnackBar("Error get files: " + error, "red");
            }
        },

        formatDetails() {
            this.calls = this.calls.map((call) => {
                return {
                    ...call,
                    duration: this.formatDuration(call.duration),
                    start: moment(call.start_at).tz(this.$store.state.timezone).format('DD/MM/YYYY, HH:mm:ss')
                };
            });
        },

        formatDuration(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const sec = seconds % 60;

            const paddedHours = hours.toString().padStart(2, '0');
            const paddedMinutes = minutes.toString().padStart(2, '0');
            const paddedSeconds = sec.toString().padStart(2, '0');

            return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
        },

        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true;
        },

        openDetailsDialog(item) {
            this.callDetails = item.all_context_details;
            this.contextDetailsDialog = true;
        },

        setDates() {
            this.endDate = Utils.getFormatDate2(new Date());
            const now = new Date();
            this.startDate = Utils.getFormatDate2(new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0));
        },

        resetDates() {
            this.setDates();
            this.debouncedFetchCalls();
        },
        // === events של סרבר פייגינג ===
        onPageChange(newPage) {
            this.currentPage = newPage;
            this.callHistory();
        },
        onItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.callHistory(true);
        },
        onSortChange() {
            this.debouncedFetchCalls(true);
        },
        handleSearchInput() {
            if (this.search) {
                this.debouncedFetchCalls(true);
            } else {
                this.callHistory(true);
            }
        }
    },
    created() {
        // Create a debounced version of getData to avoid multiple rapid calls
        this.lineNumber = Auth.getLineNumber();
        this.setDates();
        this.callHistory();
        this.debouncedFetchCalls = _.debounce(this.callHistory, 700);
    },
}
</script>

<style scoped>
.call-history-container {
    font-family: 'Heebo', sans-serif;
}

.filters-card {
    margin-bottom: 24px;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.filters-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.filters-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #0d2c6d;
    padding: 12px 16px;
    background-color: rgba(13, 44, 109, 0.05);
}

.search-field,
.date-field {
    border-radius: 8px;
}

.data-table-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    margin-bottom: 40px;
}

.data-table-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.data-table-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #0d2c6d;
    padding: 12px 16px;
    background-color: rgba(13, 44, 109, 0.05);
}

.calls-table {
    width: 100%;
}

.table-header-text {
    font-size: 16px;
    font-weight: 600;
    color: #0d2c6d;
}

.table-row {
    height: 60px !important;
    transition: background-color 0.2s ease;
}

.table-row:hover {
    background-color: rgba(13, 44, 109, 0.05) !important;
}

.table-cell {
    font-size: 14px;
    color: #333;
    text-align: center !important;
}

.caller-name,
.caller-number,
.date-display,
.duration-display {
    display: flex;
    align-items: center;
    justify-content: center;
}

.destination-chip {
    font-weight: 600;
}

.details-button {
    transition: all 0.2s ease;
    text-decoration: none;
}

.details-button:hover {
    background-color: rgba(13, 44, 109, 0.1);
    transform: translateY(-2px);
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 0;
}

.empty-text {
    font-size: 20px;
    font-weight: 600;
    color: #0d2c6d;
    margin-top: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .call-history-container {
        padding: 0 12px;
    }

    .table-header-text {
        font-size: 14px;
    }

    .table-cell {
        font-size: 13px;
    }
}

@media (max-width: 600px) {

    .filters-card,
    .data-table-card {
        border-radius: 8px;
    }
}
</style>